module.exports = __webpack_public_path__ + "static/media/10-oct16mar17.2c7dee93.pdf";